import { DisplayAlwaysPixelsApi } from '../api/DisplayAlwaysPixelsApi.js';
import '../node_modules/base64-js/index.js';

let displayAlwaysPixelsApi;
const getDisplayAlwaysPixelsApi = () => {
    if (!displayAlwaysPixelsApi) {
        displayAlwaysPixelsApi = new DisplayAlwaysPixelsApi();
    }
    return displayAlwaysPixelsApi;
};
const getPixels = async ({ acceptedConsents, ...request }) => {
    return await getDisplayAlwaysPixelsApi().getDisplayAlwaysPixels({
        consent: acceptedConsents.join(','),
        ...request,
    });
};

export { getPixels };
//# sourceMappingURL=pixelService.js.map
